import { useQuery } from "@apollo/client";

import { QR_LIST_TRIP_PUBLICATION } from "../graphQl/TripPublicationAPI";

/**
 * Liste des publications de /admin/circuits.
 *
 * - `variables` vient de buildTripPublicationsListVariables (seul point de
 *   construction des paramètres).
 * - `cache-and-network` : la liste est revalidée à chaque montage, donc un
 *   circuit créé juste avant la redirection apparaît sans rechargement manuel.
 * - `previousData` : pendant un changement de filtre ou de page, la liste
 *   précédente reste disponible pour ne pas vider la table.
 */
export const useListTripPublication = (variables, accessToken, skip = false) => {
  const query = useQuery(QR_LIST_TRIP_PUBLICATION, {
    variables,
    context: {
      headers: {
        authorization: accessToken ? `Bearer ${accessToken}` : "",
      },
    },
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange: true,
    skip,
  });

  const freshData = query.data?.QR_LIST_TRIP_PUBLICATION?.data || null;
  const tripPublicationsData =
    freshData || query.previousData?.QR_LIST_TRIP_PUBLICATION?.data || null;

  return {
    tripPublicationsData,
    freshData,
    loading: query.loading,
    // Une erreur sur la requête en cours l'emporte sur la page précédente.
    error: freshData ? null : query.error,
    refetch: query.refetch,
  };
};
